module.exports = __webpack_public_path__ + "img/wild_gold_2_b.6b77cc21.png";